import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createRole, deleteRole, fetchRole, updateRole } from "./thunks";
import { Role } from "@/types";
import { toast } from "react-toastify";

interface PaginatedRole {
  data: Role[];
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface RoleState {
  roles: PaginatedRole;
  loading: boolean;
  error: string | null;
}

const initialState: RoleState = {
  roles: { data: [] },
  loading: false,
  error: null,
};

const RoleSlice = createSlice({
  name: "Role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRole.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const payload = action.payload;
        if (Array.isArray(payload.data)) {
          state.roles = { data: payload.data };
        } else {
          state.roles = {
            data: payload.data.data,
            total: payload.data.total,
            currentPage: payload.data.current_page,
            perPage: payload.data.per_page,
          };
        }
      })
      .addCase(fetchRole.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })

      // Create
      .addCase(createRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createRole.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.roles.data.push(action.payload.data);
        toast.success("Função cadastrada com sucesso!");
      })
      .addCase(createRole.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Não foi possível cadastrar a função, tente novamente!");
      })

      // Update
      .addCase(updateRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRole.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const index = state.roles.data.findIndex(
          (s) => s.id == action.payload.data.id,
        );
        if (index !== -1) {
          state.roles.data[index] = action.payload.data;
        }
        toast.success("Função atualizada com sucesso!");
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Erro ao atualizar a função!");
      })

      // Delete
      .addCase(deleteRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteRole.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.roles.data = state.roles.data.filter(
          (s) => String(s.id) != action.payload.data.id,
        );
        toast.success("Função excluída com sucesso!");
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      });
  },
});

export default RoleSlice.reducer;
